export default ({ COLORS }) => ({
  container: ({ size }) => ({
    cursor: 'pointer',
    fontSize: size(2, { scaleFactor: 'lg' }),
    lineHeight: '1.2',
    backgroundColor: COLORS.DARK_BLUE.NORMAL,
    color: '#fff',
    borderRadius: size(0.55),
    padding: `${size(0.5, { scaleFactor: 'sm' })} ${size(1, {
      scaleFactor: 'sm'
    })}`,
    marginRight: size(0.8, { scaleFactor: 'sm' }),
    marginBottom: size(0.8, { scaleFactor: 'sm' })
  }),
  answered: {
    opacity: '0.5'
  }
})
